<template>

  <div class="broadcast-messages" v-if="getBroadcastMessages">
    <div v-for="(message, index) in getBroadcastMessages" :class="'broadcast alert '+castClass(message.level)" :key="index">
        <font-awesome-icon class="mr-2" :icon="castIcon(message.level)" />
        <button type="button" class="close p-2" data-dismiss="alert" @click="viewed(index)" v-if="message.dismissible == false">Hide</button>
        <button type="button" class="close p-2" data-dismiss="alert" @click="dismiss(index)" v-else>Dismiss</button>
        <span v-html="linkifyHtml(message.body,options)" class="message-content"></span>
    </div>
  </div>

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import { errHandler } from '@/lib/handlers'
import { EventBus } from '@/lib/events.js';
import moment from 'moment'
import linkifyHtml from 'linkify-html';

export default {
    name: 'Broadcasts',
    beforeDestroy() {
    	EventBus.$off('heartbeat-event', this.checkNewCasts); // Deregister Event Listeners
    },
    mounted() {
        EventBus.$on('heartbeat-event', this.checkNewCasts);
    },
    created() {
        this.checkNewCasts();
    },
    filters: {
        formatdate: function (value) {
            return moment(String(value)).format('MMM D hh:mm a');
        }
    },
    methods: {
        ...mapActions(['fetchBroadcasts', 'dismissBroadcast', 'viewedBroadcast','fetchPublicBroadcasts']),
        castIcon: function(level) {
            switch(level) {
                case 'info':
                    return ['fas', 'info'];
                case 'notice':
                    return ['fas', 'exclamation'];
                case 'maintenance':
                    return ['fas', 'recycle'];
                case 'important':
                    return ['fas', 'exclamation'];
                case 'emergency':
                    return ['fas', 'radiation'];
                default:
                    return ['fas', 'info'];
            }
        },
        castClass: function(level) {
            switch(level) {
                case 'info':
                    return 'alert-success';
                case 'notice':
                    return 'alert-info';
                case 'maintenance':
                    return 'alert-info';
                case 'important':
                    return 'alert-warning';
                case 'emergency':
                    return 'alert-danger';
                default:
                    return 'alert-success';
            }
        },
        dismiss: function(id) {
            if ( this.$store.state.broadcasts.broadcasts[id] && moment().isBefore(moment(this.$store.state.broadcasts.broadcasts[id].ends_at)) ) {
                this.viewedBroadcast(id).then((v) => {
                    this.dismissBroadcast(id).catch(errHandler);
                }).catch(errHandler);
            }
        },
        viewed: function(id) {
            let broadCast = this.$store.state.broadcasts.broadcasts[id];
            if (broadCast && broadCast.first_viewed_at == null && broadCast.targeted && moment().isBefore(moment(broadCast.ends_at))) {
                return this.viewedBroadcast(id);
            }
        },
        checkNewCasts: function() {
            if (this.isLoggedIn) this.fetchBroadcasts();
            else this.fetchPublicBroadcasts();
        },
        linkifyHtml
    },
    computed: {
        ...mapGetters(['getBroadcastMessages','isLoggedIn']),
        options() {
            return { defaultProtocol: 'https', target: "_blank" };
        } 
    }
}
// info(bg-info), notice(bg-primary), maintenance(bg-purple), important(bg-warning), emergency(bg-danger)
</script>

<style>
.alert {
    margin: 0 !important;
    border-radius: 0px;
}
.alert button.close {
    font-size: 0.9em;
}
.message-content a {
  text-decoration: underline; /* Add an underline to make links stand out */
}
</style>
